const IFRAME = 'worldline_saferpay_iframe';

const OFFSET_HEIGHT = 10;

export { IFRAME, OFFSET_HEIGHT };
